import geoAPI from "../../../api/geoAPI";
import { urlContexts } from "../../../constants";

const resp:any = {
  header: {},
  data:
    [
      {
        id: "001",
        name: "Lorem ipsum",
        code: "Lorem ipsum",
        pointServiceType: "Lorem ipsum",
        description: "Lorem ipsum"
      },
      {
        id: "002",
        name: "Lorem ipsum",
        code: "Lorem ipsum",
        pointServiceType: "Lorem ipsum",
        description: "Lorem ipsum"
      },
      {
        id: "003",
        name: "Lorem ipsum",
        code: "Lorem ipsum",
        pointServiceType: "Lorem ipsum",
        description: "Lorem ipsum"
      },
    ]
};

export const getServices = async (tenantid: string) => {
  const { data } = await geoAPI.get(
        `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/iuvibanking-point-service-api/rest/1.0/services`,
        {
          headers: {
            tenant: tenantid
          }
        }
      );

  return data;
};

export const createServices = async (body: any, tenantid: string) => {
  const { data } = await geoAPI.post(
        `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/iuvibanking-point-service-api/rest/1.0/services`,{
          name: body.name,
          code: body.code,
          pointServiceTypeId: body.pointServiceType,
          description: body.description,
          statusId: 1,
        },
        {
          headers: {
            tenant: tenantid
          }
        }
      );

  return data;
};

export const updateServices = async (body: any, tenantid: string) => {
  const { data } = await geoAPI.put(
        `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/iuvibanking-point-service-api/rest/1.0/services/${body.id}`,{
          name: body.name,
          code: body.code,
          pointServiceTypeId: body.pointServiceType,
          description: body.description,
          statusId: 1,
        },
        {
          headers: {
            tenant: tenantid
          }
        }
      );

  return data;
};

export const deleteServices = async (id: number, tenantid: string) => {
  const { data } = await geoAPI.delete(
        `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/iuvibanking-point-service-api/rest/1.0/services/${id}`,
        {
          headers: {
            tenant: tenantid
          }
        }
      );

  return data;
};
